//type: class

import { Nullable } from '@rotomeca/utils';

/**
 * Élément à ajouter dans un slot avec un nom de slot optionnel.
 */
export class ScheduleElementAppend {
	#_element: Element;
	#_slot: Nullable<string>;

	/**
	 * Constructeur de la classe ScheduleElementAppend.
	 * @param element Element à ajouter
	 * @param slot Dans quel slot (null pour le slot principal)
	 */
	constructor(element: Element, slot: Nullable<string> = null) {
		this.#_element = element;
		this.#_slot = slot;
	}

	/**
	 * Retourne l'élément à ajouter.
	 */
	get element(): Element {
		return this.#_element;
	}

	/**
	 * Retourne le nom du slot où ajouter l'élément.
	 */
	get slot(): Nullable<string> {
		return this.#_slot;
	}
}
